import React, { useRef } from "react";
import { useEffect, useState } from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Autocomplete,
  FormGroup,
  CircularProgress, 
} from "@mui/material";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputAdornment from "@mui/material/InputAdornment";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import AccountCircle from "@mui/icons-material/AccountCircle";
import SaveIcon from "@mui/icons-material/Save";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import InputMask from "react-input-mask";
import moment from "moment";
import { getCodeArg, getData, putData } from "../../../../../services/library";
import Notify from "../../../../Notify";

function EdicionEnvasado(props) {
  const [dataCliente, setDataCliente] = useState({});
  const [sucursales, setSucursales] = useState(null);
  const [localidades, setLocalidades] = useState(null);
  const [comerciales, setComerciales] = useState(null);
  const [provincias, setProvincias] = useState(null);
  const [tipo, setTipo] = useState(dataCliente.afip_tipodoc_cli);
  const [condiciones, setCondiciones] = useState(null);
  // const [categorias, setCategorias] = useState(null);
  const [convenios, setConvenios] = useState(null)
  const [sitIva, setSitIva] = useState(null);
  const [tipoCliente, setTipoCliente] = useState(null);
  const [usos, setUsos] = useState(null);
  const [disBtn, setDisBtn] = useState(false);
  const [sitIvaSeleccionada, setSitIvaSeleccionada] = useState("");
  const [condPagoSeleccionada, setCondPagoSeleccionada] = useState("");
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [provinciaSeleccionada, setProvinciaSeleccionada] = useState("");
  const [localidadSeleccionada, setLocalidadSeleccionada] = useState("");
  const [comercialSeleccionado, setComercialSeleccionado] = useState("");
  // const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("");
  const [convenioSeleccionado, setConvenioSeleccionado] = useState("")
  const [tipoClienteSeleccionado, setTipoClienteSeleccionado] = useState("");
  
  const [usoSeleccionado, setUsoSeleccionado] = useState("");
  const [buscando, setBuscando] = useState(false);
  const [checked, setChecked] = useState(dataCliente.factura_consfinal === 1 ? true : false);
  const [loading, setLoading] = useState(true); 
  const [checkedPrecioEspecial, setCheckedPrecioEspecial] = useState(
    dataCliente.precio_especial === 1 ? true : false
  );
  useEffect(() => {
    setChecked(dataCliente.factura_consfinal === 1 ? true : false)
  }, [dataCliente.factura_consfinal])
  useEffect(() => {
    setCheckedPrecioEspecial(dataCliente.precio_especial === 1 ? true : false)
  }, [dataCliente.precio_especial])
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  const [codArg, setCodArg] = useState("");
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const obtenerCliente = () => {
    setLoading(true);
    getData("/envasado_clientes/xid/" + props.cliente.id, (data) => {
      if (Array.isArray(data) && data.length > 0) {
        setDataCliente(data[0]);
      }
      setLoading(false);
    });
  };
  useEffect(() => {
    obtenerCliente();
  }, []);
  const handleChangeChecked = (event) => {
    setChecked(event.target.checked);
  };

  const handleCheckedPrecioEspecial = (event) => {
    setCheckedPrecioEspecial(event.target.checked);
  };

  const almacenar = (e) => {
    setDataCliente({
      ...dataCliente,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };
  //******************************************************************************************************** */
  //Fetchs para traer datos de la api a los desplegables
  useEffect(() => {
    getData("/sucursales", setSucursales);
  }, [dataCliente.id_tipocliente]);

  useEffect(() => {
    // getData("/categorias", setCategorias);
    getData("/convenios", setConvenios);
    getData("/representantes/activos", setComerciales);
    getData("/provincias", setProvincias);
    getData("/condicion_pago", setCondiciones);
    getData("/condiciones_iva/envasado", setSitIva);
    getData("/tipoclienteenvasado", setTipoCliente);
    getData("/envasado_usos", setUsos);
    getCodeArg(setCodArg);
  }, []);

  useEffect(() => {
    getData("/localidades/prov/" + provinciaSeleccionada?.id, setLocalidades);
    setBuscando(false);
  }, [dataCliente.id_provincia, provinciaSeleccionada]);

  useEffect(() => {
    getData("/localidades/prov/" + provinciaSeleccionada?.id, setLocalidades);

    if (!(dataCliente.id_provincia === provinciaSeleccionada.id)) {
      setLocalidadSeleccionada("");
    }
    setBuscando(false);
  }, [dataCliente.id_provincia, provinciaSeleccionada]);

  const handleClose = () => {
    props.setOpen(false);
  };

  async function guardarCliente(e) {
    setDisBtn(true);
    putData(
      e,
      "/envasado_clientes/" + dataCliente.id,
      {
        usuario: localStorage.getItem("user"),
        sisven_id: dataCliente.sisven_id === "" ? null : dataCliente.sisven_id,
        razon_social: dataCliente.razon_social,
        direccion_fiscal: dataCliente.direccion_fiscal,
        telefono_1: dataCliente.telefono_1
          ? dataCliente.telefono_1
          : null,
        telefono_2: dataCliente.telefono_2
          ? dataCliente.telefono_2
          : null,
        telefono_3: dataCliente.telefono_3
          ? dataCliente.telefono_3
          : null,
        mails: dataCliente.mails,
        cuit: dataCliente.cuit,
        id_sucursal: sucursalSeleccionada.id,
        // id_categoria: categoriaSeleccionada.id,
        id_localidad: localidadSeleccionada.id,
        id_comercial: comercialSeleccionado.id,
        // id_provincia: provinciaSeleccionada.id,
        situacion_iva: sitIvaSeleccionada.id,
        id_condicionpago: condPagoSeleccionada.id,
        // limite_credito:
        //   dataCliente.limite_credito === "" ? null : dataCliente.limite_credito,
        id_tipocliente: tipoClienteSeleccionado.id,
        observaciones: dataCliente.observaciones,
        // envase_10_kg: dataCliente.envase_10_kg,
        // envase_15_kg: dataCliente.envase_15_kg,
        // envase_45_kg: dataCliente.envase_45_kg,
        uso: usoSeleccionado.id,
        tipo_doc_afip: dataCliente.afip_tipodoc_cli,
        factura_consfinal: dataCliente.factura_consfinal,
        porc_perc_iva: dataCliente.porc_perc_iva,
        porc_exc_perc_iva: dataCliente.porc_exc_perc_iva,
        vto_exc_perc_iva: dataCliente.vto_exc_perc_iva,
        precio_especial: dataCliente.precio_especial,
        id_convenio: convenioSeleccionado.id_convenio,
        iibb_nro_inscripcion:dataCliente.iibb_nro_inscripcion
      },
      setNotificacion
    );
  }

  useEffect(() => {
    // sitIva
    if (dataCliente.situacion_iva !== "" && sitIva) {
      const sitEncontrada = sitIva.find(
        (d) => d.id === parseInt(dataCliente.situacion_iva)
      );
      if (sitEncontrada) {
        setSitIvaSeleccionada(sitEncontrada);
      }
    }
  }, [sitIva,dataCliente.situacion_iva]);

  useEffect(() => {
    // cond Pago
    if (dataCliente.id_condicionpago !== "" && condiciones) {
      const condicionEncontrada = condiciones.find(
        (d) => d.id === dataCliente.id_condicionpago
      );
      if (condicionEncontrada) {
        setCondPagoSeleccionada(condicionEncontrada);
      }
    }
  }, [condiciones,dataCliente.id_condicionpago]);

  useEffect(() => {
    // sucursal
    if (dataCliente.id_sucursal !== "" && sucursales) {
      const sucursalEncontrada = sucursales.find(
        (d) => d.id === dataCliente.id_sucursal
      );
      if (sucursalEncontrada) {
        setSucursalSeleccionada(sucursalEncontrada);
      }
    }
  }, [sucursales, dataCliente.id_sucursal]);

  useEffect(() => {
    // provincia
    if (dataCliente.id_provincia !== "" && provincias) {
      const provinciaEncontrada = provincias.find(
        (d) => d.id === dataCliente.id_provincia
      );
      if (provinciaEncontrada) {
        setProvinciaSeleccionada(provinciaEncontrada);
      }
    }
  }, [provincias, dataCliente.id_provincia]);

  useEffect(() => {
    // localidad
    if (dataCliente.id_localidad && localidades?.length) {
      const localidadEncontrada = localidades.find(
        (d) => d.id === Number(dataCliente.id_localidad)
      );

      if (localidadEncontrada) {
        setLocalidadSeleccionada(localidadEncontrada);
      }
    }
  }, [localidades, dataCliente.id_localidad]);

  useEffect(() => {
    // comerciales
    if (dataCliente.id_comercial !== "" && comerciales) {
      const comercialEncontrado = comerciales.find(
        (d) => d.id === dataCliente.id_comercial
      );
      if (comercialEncontrado) {
        setComercialSeleccionado(comercialEncontrado);
      }
    }
  }, [comerciales, dataCliente.id_comercial]);

  // useEffect(() => {
  //   // categorias
  //   if (dataCliente.id_categoria !== "" && categorias) {
  //     const categoriaEncontrada = categorias.find(
  //       (d) => d.id === dataCliente.id_categoria
  //     );
  //     if (categoriaEncontrada) {
  //       setCategoriaSeleccionada(categoriaEncontrada);
  //     }
  //   }
  // }, [categorias, dataCliente.id_categoria]);

  useEffect(() => {
    // convenios
    if (dataCliente.id_convenio !== "" && convenios) {
      const convenioEncontrado = convenios.find(
        (d) => d.id_convenio === dataCliente.id_convenio
      );
      if (convenioEncontrado) {
        setConvenioSeleccionado(convenioEncontrado);
      }
    }
  }, [convenios, dataCliente.id_convenio]);

  useEffect(() => {
    // tipo cliente
    if (dataCliente.id_tipocliente !== "" && tipoCliente) {
      const tipoEncontrado = tipoCliente.find(
        (d) => d.id === dataCliente.id_tipocliente
      );
      if (tipoEncontrado) {
        setTipoClienteSeleccionado(tipoEncontrado);
      }
    }
  }, [tipoCliente, dataCliente.id_tipocliente]);
// console.log("ripo",tipoClienteSeleccionado, dataCliente);

  useEffect(() => {
    // uso
    if (dataCliente.uso !== "" && usos) {
      const usoEncontrado = usos.find((d) => d.id === dataCliente.uso);
      if (usoEncontrado) {
        setUsoSeleccionado(usoEncontrado);
      }
    }
  }, [usos, dataCliente.uso]);

  useEffect(() => {
    let respInscrip = sitIvaSeleccionada?.id === 1 ? 1.75 : null;
    let tieneExencion =
      sitIvaSeleccionada?.id === 1 ? dataCliente.porc_exc_perc_iva : null;
    let vencimientoExencion =
      sitIvaSeleccionada?.id === 1 ? dataCliente.vto_exc_perc_iva : null;

    if (sitIvaSeleccionada?.id === 4) {
      setDataCliente((prev) => ({
        ...prev,
        porc_perc_iva: respInscrip,
        porc_exc_perc_iva: tieneExencion,
        vto_exc_perc_iva: vencimientoExencion,
      }));
    } else if (
      Object.keys(sitIvaSeleccionada).length !== 0 &&
      sitIvaSeleccionada?.id !== 4
    ) {
      setDataCliente((prev) => ({
        ...prev,
        afip_tipodoc_cli: 80,
        porc_perc_iva: respInscrip,
        porc_exc_perc_iva: tieneExencion,
        vto_exc_perc_iva: vencimientoExencion,
      }));
    }
  }, [sitIvaSeleccionada]);

  useEffect(() => {
    // if (props.cliente.tipo_doc_afip === dataCliente.afip_tipodoc_cli) {
      setDataCliente((prev) => ({
        ...prev,
        cuit: dataCliente.cuit,
      }));
    // } else {
    //   setDataCliente((prev) => ({
    //     ...prev,
    //     cuit: "",
    //   }));
    // }
  }, [dataCliente.afip_tipodoc_cli]);

  useEffect(() => {
    if (checked === true) {
      setDataCliente((prev) => ({
        ...prev,
        factura_consfinal: 1,
      }));
    } else {
      setDataCliente((prev) => ({
        ...prev,
        factura_consfinal: 0,
      }));
    }
  }, [checked]);

    useEffect(() => {
    if (checkedPrecioEspecial === true) {
      setDataCliente((prev) => ({
        ...prev,
        precio_especial: 1,
      }));
    } else {
      setDataCliente((prev) => ({
        ...prev,
        precio_especial: 0,
      }));
    }
  }, [checkedPrecioEspecial]);

  // Guardar el id_convenio anterior
  const prevConvenioIdRef = useRef(convenioSeleccionado?.id_convenio);
  
  useEffect(() => {
    const prevId = prevConvenioIdRef.current;
    const currentId = convenioSeleccionado?.id_convenio;
    
    // Solo limpiar si realmente cambió el convenio (no cuando se carga por primera vez)
    if (prevId !== undefined && prevId !== currentId && currentId !== undefined) {
      setDataCliente((prev) => ({
        ...prev,
        iibb_nro_inscripcion: null,
      }));
    }
    
    prevConvenioIdRef.current = currentId;
  }, [convenioSeleccionado?.id_convenio]);

  return (
    <div>
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => handleClose()}
        maxWidth="xl"
      >
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => {
              props.setOpen(false);
              props.actualizar();
            }}
            severity={notificacion.severity}
          />
        ) : null}
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Editar cliente {dataCliente.razon_social}
            </Typography>
          </DialogTitle>
        </Box>
        {loading ? (
          <DialogContent>
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
              <CircularProgress />
              <Typography variant="h6" sx={{ ml: 2 }}>
                Cargando datos del cliente...
              </Typography>
            </Box>
          </DialogContent>
        ) : (
        <form onSubmit={guardarCliente}>
          <DialogContent>
              <Grid container spacing={1.2}>
                <Grid item xs={3}>
                  <TextField
                    size="small"
                    focused
                    style={style}
                    placeholder="Razon Social"
                    type="text"
                    required
                    name="razon_social"
                    label="Razon Social"
                    onChange={almacenar}
                    value={
                      dataCliente.razon_social &&
                      dataCliente.razon_social.replace(/\b\w/g, (l) =>
                        l.toUpperCase()
                      )
                    }
                    inputProps={{ maxLength: 200 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={sitIvaSeleccionada?.id === 1 ? 1.5 : 2}>
                  <TextField
                    size="small"
                    style={style}
                    placeholder="Sisven ID"
                    type="text"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputProps={{ maxLength: 6 }} //solo 2 numeros
                    focused
                    name="sisven_id"
                    label="Sisven ID"
                    color="primary"
                    onChange={almacenar}
                    value={dataCliente.sisven_id}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MeetingRoomIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={sitIvaSeleccionada?.id === 1 ? 1.5 : 3}>
                  <Autocomplete
                    disabled={!tipoCliente}
                    required
                    disableClearable
                    id="id_tipocliente"
                    style={style}
                    size="small"
                    noOptionsText={"Tipo de Cliente INEXISTENTE"}
                    options={tipoCliente}
                    autoHighlight
                    getOptionLabel={(tc) => tc.descripcion}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={tipoClienteSeleccionado || null}
                    defaultValue={tipoClienteSeleccionado || null}
                    onChange={(event, value) => {
                      setTipoClienteSeleccionado(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.descripcion}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Tipo Cliente"
                        focused
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={sitIvaSeleccionada?.id === 1 ? 2.5 : 4}>
                  <Autocomplete
                    disabled={!sitIva}
                    required
                    disableClearable
                    id="sitIva"
                    style={style}
                    size="small"
                    noOptionsText={"Situación de IVA INEXISTENTE"}
                    options={sitIva}
                    autoHighlight
                    getOptionLabel={(sit) => sit.descripcion}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={sitIvaSeleccionada || null}
                    defaultValue={sitIvaSeleccionada || null}
                    onChange={(event, value) => {
                      setSitIvaSeleccionada(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.descripcion}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Situación IVA"
                        focused
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                {sitIvaSeleccionada?.id === 1 ? (
                  <>
                    <Grid item xs={1.75}>
                      <TextField
                        size="small"
                        style={{ backgroundColor: "#fff" }}
                        fullWidth
                        required
                        placeholder=""
                        disabled={sitIvaSeleccionada?.id === 1 ? false : true}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        inputProps={{ maxLength: 9 }} //solo 2 numeros
                        name="porc_exc_perc_iva"
                        label="% Exención Perc. IVA"
                        color="primary"
                        onChange={almacenar}
                        value={dataCliente.porc_exc_perc_iva}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">%</InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={1.75}>
                      <TextField
                        size="small"
                        style={{ backgroundColor: "#fff" }}
                        fullWidth
                        required={parseInt(dataCliente.porc_exc_perc_iva)===0?false:true}
                        placeholder=""
                        disabled={sitIvaSeleccionada?.id === 1 ? false : true}
                        type="date"
                        inputProps={{ maxLength: 9 }} //solo 2 numeros
                        name="vto_exc_perc_iva"
                        label="Vencimiento Exención"
                        color="primary"
                        onChange={almacenar}
                        value={moment(dataCliente.vto_exc_perc_iva).format(
                          "YYYY-MM-DD"
                        )}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start"></InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </>
                ) : null}
                {/* <Grid item xs={4}>
                  <Autocomplete
                    disabled={!categorias}
                    required
                    disableClearable
                    id="categoria"
                    // name="id_provincia"
                    style={style}
                    size="small"
                    noOptionsText={"Categoria Crediticia INEXISTENTE"}
                    options={categorias}
                    autoHighlight
                    // filterOptions={filterOptions}
                    getOptionLabel={(cat) =>
                      cat.categoria + " " + "(" + cat.descripcion + ")"
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={categoriaSeleccionada || null}
                    defaultValue={categoriaSeleccionada || null}
                    onChange={(event, value) => {
                      setCategoriaSeleccionada(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.categoria} ({option.descripcion})
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Categoría Crediticia"
                        focused
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid> */}

                <Grid item xs={1}>
                  <FormControl required style={style} focused size="small">
                    <InputLabel>Cuit/Dni</InputLabel>
                    <Select
                      name="afip_tipodoc_cli"
                      labelId="Cuit/Dni"
                      disabled={sitIvaSeleccionada?.id !== 4}
                      value={dataCliente.afip_tipodoc_cli}
                      label="afip_tipodoc_cli"
                      onChange={almacenar}
                    >
                      <MenuItem value={80}>Cuit</MenuItem>
                      <MenuItem value={96}>Dni</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {dataCliente.afip_tipodoc_cli === 80 ? (
                  <Grid item xs={2}>
                    <InputMask
                      mask="99999999999"
                      value={dataCliente.cuit}
                      disabled={false}
                      maskChar=" "
                      onChange={almacenar}
                    >
                      {() => (
                        <TextField
                          size="small"
                          style={style}
                          type="text"
                          focused
                          name="cuit"
                          label="Numero Cuit"
                        />
                      )}
                    </InputMask>
                  </Grid>
                ) : (
                  <Grid item xs={2}>
                    <InputMask
                      mask="99999999"
                      value={dataCliente.cuit}
                      disabled={false}
                      maskChar=" "
                      onChange={almacenar}
                    >
                      {() => (
                        <TextField
                          size="small"
                          style={style}
                          type="text"
                          focused
                          name="cuit"
                          label="Numero Dni"
                        />
                      )}
                    </InputMask>
                  </Grid>
                )}
                <Grid item xs={2}>
                  <Autocomplete
                    disabled={!condiciones}
                    required
                    disableClearable
                    id="id_condicionpago"
                    // name="id_provincia"
                    style={style}
                    size="small"
                    noOptionsText={"Condición de Pago INEXISTENTE"}
                    options={condiciones}
                    autoHighlight
                    // filterOptions={filterOptions}
                    getOptionLabel={(cond) => cond.condicion}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={condPagoSeleccionada || null}
                    defaultValue={condPagoSeleccionada || null}
                    onChange={(event, value) => {
                      setCondPagoSeleccionada(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.condicion}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Condición de Pago"
                        focused
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                {/* <Grid item xs={2}>
                  <TextField
                    size="small"
                    style={style}
                    fullWidth
                    placeholder="100000"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputProps={{ maxLength: 9 }} //solo 2 numeros
                    focused
                    name="limite_credito"
                    label="Límite de crédito"
                    color="primary"
                    onChange={almacenar}
                    value={dataCliente.limite_credito}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">$</InputAdornment>
                      ),
                    }}
                  />
                </Grid> */}
                <Grid item xs={3}>
                  <TextField
                    size="small"
                    style={style}
                    focused
                    placeholder="Direccion Fiscal"
                    id="direccion_fiscal"
                    name="direccion_fiscal"
                    label="Direccion Fiscal"
                    color="primary"
                    value={
                      dataCliente.direccion_fiscal &&
                      dataCliente.direccion_fiscal.replace(/\b\w/g, (l) =>
                        l.toUpperCase()
                      )
                    }
                    onChange={almacenar}
                    inputProps={{ maxLength: 120 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LocationOnIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={4}>
                  <Autocomplete
                    disabled={!sucursales}
                    required
                    disableClearable
                    id="id_sucursal"
                    style={style}
                    size="small"
                    noOptionsText={"Sucursal INEXISTENTE"}
                    options={sucursales}
                    autoHighlight
                    getOptionLabel={(suc) => suc.nombre}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={sucursalSeleccionada || null}
                    defaultValue={sucursalSeleccionada || null}
                    onChange={(event, value) => {
                      setSucursalSeleccionada(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.nombre}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Sucursal"
                        focused
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Autocomplete
                    disabled={!provincias}
                    required
                    disableClearable
                    id="id_provincia"
                    // name="id_provincia"
                    style={style}
                    size="small"
                    noOptionsText={"Provincia INEXISTENTE"}
                    options={provincias}
                    autoHighlight
                    // filterOptions={filterOptions}
                    getOptionLabel={(pr) => pr.provincia}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={provinciaSeleccionada || null}
                    defaultValue={provinciaSeleccionada || null}
                    onChange={(event, value) => {
                      setProvinciaSeleccionada(value);
                      setBuscando(true);
                      dataCliente.id_localidad = "";
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.provincia}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Provincia"
                        focused
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  {buscando === true ? (
                    <TextField
                      disabled
                      focused
                      fullWidth
                      size="small"
                      label="Buscando Localidades..."
                    />
                  ) : (
                    <Autocomplete
                      disabled={!localidades}
                      required
                      disableClearable
                      id="id_localidad"
                      style={style}
                      size="small"
                      noOptionsText={"Localidad INEXISTENTE"}
                      options={localidades}
                      autoHighlight
                      getOptionLabel={(loc) => loc.localidad}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value?.id
                      }
                      value={localidadSeleccionada || null}
                      defaultValue={localidadSeleccionada || null}
                      onChange={(event, value) => {
                        setLocalidadSeleccionada(value);
                      }}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          key={option.id}
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {option.localidad}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          placeholder="Tipee para buscar..."
                          {...params}
                          label="Localidad"
                          focused
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                    />
                  )}
                </Grid>

                <Grid item xs={3}>
                  <Autocomplete
                    disabled={!comerciales}
                    required
                    disableClearable
                    id="id_comercial"
                    style={style}
                    size="small"
                    noOptionsText={"Comercial INEXISTENTE"}
                    options={comerciales}
                    autoHighlight
                    getOptionLabel={(c) => c.nombre_apellido}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={comercialSeleccionado || null}
                    defaultValue={comercialSeleccionado || null}
                    onChange={(event, value) => {
                      setComercialSeleccionado(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.nombre_apellido}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Comercial"
                        focused
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                {/* <Grid item xs={2}>
                  <FormControl fullWidth>
                    <TextField
                      size="small"
                      style={{ backgroundColor: "#fff" }}
                      fullWidth
                      type="number"
                      color="primary"
                      placeholder="..."
                      name="envase_10_kg"
                      label="Envase 10 KG"
                      focused
                      onChange={almacenar}
                      value={dataCliente.envase_10_kg}
                      inputProps={{
                        maxLength: 10,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <FormControl fullWidth>
                    <TextField
                      size="small"
                      style={{ backgroundColor: "#fff" }}
                      fullWidth
                      type="number"
                      color="primary"
                      placeholder="..."
                      name="envase_15_kg"
                      label="Envase 15 KG"
                      focused
                      onChange={almacenar}
                      value={dataCliente.envase_15_kg}
                      inputProps={{
                        maxLength: 10,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <FormControl fullWidth>
                    <TextField
                      size="small"
                      style={{ backgroundColor: "#fff" }}
                      fullWidth
                      type="number"
                      color="primary"
                      placeholder="..."
                      name="envase_45_kg"
                      label="Envase 45 KG"
                      focused
                      onChange={almacenar}
                      value={dataCliente.envase_45_kg}
                      inputProps={{
                        maxLength: 10,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </FormControl>
                </Grid> */}
                <Grid item xs={3}>
                  <Autocomplete
                    disabled={!usos}
                    required
                    disableClearable
                    id="uso"
                    style={style}
                    size="small"
                    noOptionsText={"Uso INEXISTENTE"}
                    options={usos}
                    autoHighlight
                    getOptionLabel={(u) => u.uso}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={usoSeleccionado || null}
                    defaultValue={usoSeleccionado || null}
                    onChange={(event, value) => {
                      setUsoSeleccionado(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.uso}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Uso"
                        focused
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                {sitIvaSeleccionada?.inscripcion_iibb===1?
              <>
               <Grid item xs={3}>
                <Autocomplete
                  disabled={!convenios}
                  // required
                  disableClearable
                  id="convenios"
                  style={style}
                  size={"small"}
                  noOptionsText={"Convenio INEXISTENTE"}
                  options={convenios}
                  autoHighlight
                  getOptionLabel={(c) =>
                    c.id_convenio + "-" + c.convenio
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id_convenio === value?.id_convenio
                  }
                  value={convenioSeleccionado || null}
                  defaultValue={convenioSeleccionado || null}
                  onChange={(event, value) => {
                    setConvenioSeleccionado(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id_convenio}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id_convenio} - {option.convenio}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      required
                      focused
                      {...params}
                      label="Convenio"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size={"small"}
                  style={style}
                  placeholder="N° Inscripción IIBB"
                  id="iibb_nro_inscripcion"
                  name="iibb_nro_inscripcion"
                  label="N° Inscripción IIBB"
                  color="primary"
                  value={dataCliente.iibb_nro_inscripcion || ''}
                  focused
                  onChange={(e) => almacenar(e)}
                  inputProps={{ 
                    maxLength: convenioSeleccionado?.id_convenio === 1 ? 13 : 200 
                  }}
                />
              </Grid>
              </>
              :null}
                <Grid item xs={sitIvaSeleccionada?.inscripcion_iibb===1?6:12}>
                  <TextField
                    size="small"
                    style={style}
                    placeholder="Observaciones"
                    id="observaciones"
                    name="observaciones"
                    label="Observaciones"
                    color="primary"
                    focused
                    value={dataCliente.observaciones}
                    onChange={almacenar}
                    inputProps={{ maxLength: 200 }}
                  />
                </Grid>
                <Grid item xs={9.6}>
                  <TextField
                    style={style}
                    size="small"
                    focused
                    placeholder="Mails"
                    id="mails"
                    name="mails"
                    label="Mails"
                    color="primary"
                    value={dataCliente.mails}
                    onChange={almacenar}
                    inputProps={{ maxLength: 500 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ContactMailIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={2.4} alignContent={"unset"}>
                  <FormGroup>
                    <FormControlLabel
                      label="Precio Especial"
                      control={
                        <Checkbox
                          checked={checkedPrecioEspecial}
                          onChange={handleCheckedPrecioEspecial}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={3.2}>
                  <TextField
                    style={style}
                    size="small"
                    type="text"
                    focused
                    color="primary"
                    placeholder="Telefono 1"
                    name="telefono_1"
                    id="telefono_1"
                    label="Telefono 1"
                    onChange={almacenar}
                    value={dataCliente.telefono_1}
                    inputProps={{
                      maxLength: 10,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {codArg}
                        </InputAdornment>
                      ),
                    }}
                    helperText="Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={3.2}>
                  <TextField
                    style={style}
                    size="small"
                    type="text"
                    focused
                    color="primary"
                    placeholder="Telefono 2"
                    name="telefono_2"
                    label="Telefono 2"
                    onChange={almacenar}
                    value={dataCliente.telefono_2}
                    inputProps={{
                      maxLength: 10,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {codArg}
                        </InputAdornment>
                      ),
                    }}
                    helperText="Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={3.2}>
                  <TextField
                    style={style}
                    size="small"
                    type="text"
                    focused
                    color="primary"
                    placeholder="Telefono 3"
                    name="telefono_3"
                    label="Telefono 3"
                    onChange={almacenar}
                    value={dataCliente.telefono_3}
                    inputProps={{
                      maxLength: 10,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {codArg}
                        </InputAdornment>
                      ),
                    }}
                    helperText="Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={2.4} alignContent={"unset"}>
                  <FormGroup>
                    <FormControlLabel
                      label="Factura Consumidor Final"
                      control={
                        <Checkbox
                          checked={checked}
                          onChange={handleChangeChecked}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                    />
                  </FormGroup>
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                mt={1}
              >
                <Grid item>
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={() => handleClose()}
                    style={{ backgroundColor: "#fff" }}
                  >
                    Volver
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    type="submit"
                    color="success"
                    variant="contained"
                    disabled={disBtn}
                    endIcon={<SaveIcon />}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            {/* </Box> */}
          </DialogContent>
        </form>
        )}
      </Dialog>
    </div>
  );
}

export default EdicionEnvasado;
